import { accountTypes } from './types';
import { decodeToken } from "../helpers/tokenHelper";

const logIn = token => dispatch => {
    try {
        var { unique_name, fullName, roles, exp, dynamicsId } = decodeToken(token);
        dispatch({
            type: accountTypes.LOGIN,
            payload: { unique_name, fullName, roles, exp, dynamicsId }
        });
    } catch (e) {
        dispatch(invalidToken());
        // TODO mostrar error si no es referido al token
    }
};

const logOut = () => {
    localStorage.removeItem('token');

    return {
        type: accountTypes.LOGOUT
    };
};


const changeDynamicsId = (salesData, customer) => (dispatch) => {
    dispatch({
        type: accountTypes.CHANGE_DYNAMICS_ID,
        payload: { salesData, customer }
    });
};


const removeCustomerId = (data) => (dispatch) => {
    dispatch({
        type: accountTypes.REMOVE_CUSTOMER_ID,
        payload: data
    })
}

const invalidToken = () => dispatch => {
    dispatch({ type: accountTypes.INVALID_TOKEN });
    dispatch(logOut());
};

export const accountActions = {
    logIn,
    logOut,
    changeDynamicsId,
    removeCustomerId,
    invalidToken
};